import React from "react";
import { Alert } from "antd";
import { Guardian, LinkedStudent } from "../../../../types/guardianTypes";
// removed getLinkedStudents import since we don't fetch here
import CustomModal from "../../../Common/CustomModal";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import { useAbility } from "config/abilityContext";
import { formatToLocaleDate } from "utils/dateUtils";
import ActionsDropdown, { Action } from "components/Common/ActionsDropdown";
import UserStatusBadge from "components/Common/Badge/UserStatusBadge";
import UserProfileHeader from "components/Common/ui/UserProfileHeader";

interface GuardianDetailsModalProps {
  guardian: Guardian;
  onClose: () => void;
}

const GuardianDetailsModal: React.FC<GuardianDetailsModalProps> = ({ guardian, onClose }) => {
  const { t } = useTranslation();
  const ability = useAbility();
  //  useEffect(() => {
  //     const fetchStudents = async () => {
  //       try {
  //         const response = await getLinkedStudents(guardian.id);
  //         setStudents(response.data);
  //       } catch {

  //       } finally {
  //         setLoading(false);
  //       }
  //     };
  //     fetchStudents();
  //   }, [guardian.id]);
  const buildActions = (student: LinkedStudent): Action[] => [
    {
      label: t("edit"),
      icon: "ti ti-edit",
      hidden: !ability.can("update", "Student"),
      actionType: "link",
      to: all_routes.editStudent.replace(":id", student.id),
    },
    {
      label: t("fees"),
      icon: "ti ti-report-money",
      hidden: !ability.can("getAll", "Fee"),
      actionType: "link",
      to: all_routes.studentDetails.replace(":id", student.id) + all_routes.studentDetailsTabs.fees,
    },
  ];

  const linked = guardian?.linkedStudents || [];

  return (
    <CustomModal
      isOpen={!!guardian}
      title={t("details")}
      onClose={onClose}
    >
      <div className="modal-body mb-0 mt-2">
        <div className="parent-wrap px-3">
          <div className="row align-items-center mb-4">
            <div className="col-lg-6">
              <div className="d-flex align-items-center">
                <span className="avatar avatar-xl me-3">
                  <img
                    alt="guardian"
                    src={guardian.user.photo}
                    className="img-fluid rounded-circle"
                  />
                </span>
                <div className="parent-name">
                  <h5 className="mb-1">
                    {guardian.user.firstName} {guardian.user.lastName}
                  </h5>
                  <p className="text-muted mb-0">
                    {t("joined_on")} {formatToLocaleDate(guardian.createdAt)}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <ul className="list-unstyled d-flex align-items-start flex-wrap gap-4 mb-0">
                <li>
                  <p className="mb-1"><b>{t("email")} :</b></p>
                  <h6 className="fw-normal mb-0">{guardian.user.email || "—"}</h6>
                </li>
                <li>
                  <p className="mb-1"><b>{t("phone")} :</b></p>
                  <h6 className="fw-normal mb-0">{guardian.user.phoneNumber || "—"}</h6>
                </li>
              </ul>
            </div>
          </div>

          <h5 className="mb-3">{t("children_details")}</h5>

          {linked.length === 0 ? (
            <Alert message={t("no_linked_students_found")} type="warning" showIcon />
          ) : (
            linked.map((student) => (
              <div key={student.id} className="border rounded p-4 pb-2 mb-3">
                <div className="d-flex align-items-center justify-content-between flex-wrap pb-2 mb-3 border-bottom">
                  <div className="d-flex align-items-center">
                    <span className="link-primary me-3">
                      {student.massarCode || student.id}
                    </span>
                    <span className="badge bg-light text-dark rounded-pill">
                      {student.class?.name || t("no_class")}
                    </span>
                  </div>
                  <UserStatusBadge status={student.status as any} />
                </div>

                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <UserProfileHeader
                    firstName={student.user.firstName}
                    lastName={student.user.lastName}
                    photo={student.user.photo}
                    subtitle={student.massarCode}
                    canRedirect={ability.can("getAll", "Student")}
                    to={all_routes.studentDetails.replace(":id", student.id) + all_routes.studentDetailsTabs.details}
                  />



                  <ul className="d-flex align-items-center flex-wrap gap-4 mb-3">
                    {student.user.gender && (
                      <li>
                        <p className="mb-1">{t("gender")}</p>
                        <h6 className="fw-normal mb-0">{t(student.user.gender)}</h6>
                      </li>
                    )}
                    {student.createdAt && (
                      <li>
                        <p className="mb-1">{t("joined_on")}</p>
                        <h6 className="fw-normal mb-0">
                          {formatToLocaleDate(student.createdAt)}
                        </h6>
                      </li>
                    )}
                  </ul>

                  <div className="d-flex align-items-center">
                    <ActionsDropdown actions={buildActions(student)} />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default GuardianDetailsModal;
